import { render, staticRenderFns } from "./productCli.vue?vue&type=template&id=961c1132&scoped=true"
import script from "./productCli.vue?vue&type=script&lang=js"
export * from "./productCli.vue?vue&type=script&lang=js"
import style0 from "./productCli.vue?vue&type=style&index=0&id=961c1132&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961c1132",
  null
  
)

export default component.exports